import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=0d5f376d&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=ts"
export * from "./Btn.vue?vue&type=script&lang=ts"
import style0 from "./Btn.vue?vue&type=style&index=0&id=0d5f376d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f376d",
  null
  
)

export default component.exports